import {IQaRegistrationRegistrationStep} from './qa-registration-registrationstep';

export interface IQaRegistrationGetRegistrationStepsResponse {
    data: {
        success: boolean,
        results: IQaRegistrationRegistrationStep[]
    }
}